import Home from '../../views/Home.vue';
import profileRoutes from './profile';
import calendarRoutes from './calendar';
import workRoutes from './work';
import articleRoutes from './article';
import quoteRoutes from './quote';
import proposalRoutes from './proposal';
import vacationRoutes from './vacation';
import newsletterRoutes from './newsletter';
import settingsRoutes from './settings';
import salesReportRoutes from './sales-report';
import statisticRoutes from './statistic';
import evaluatorRoutes from './evaluator';

export function load(component: string) {
    return () => import(/* webpackChunkName: "[request]" */ `@/views/${component}.vue`);
}

export default [
    {
        path: '/login',
        name: 'login',
        component: load('Login'),
        meta: { guest: true },
    },
    {
        path: '/join/:invitationId',
        name: 'join',
        component: load('Join'),
        meta: { guest: true },
    },
    {
        path: '/password/reset',
        name: 'reset-password',
        component: load('PasswordReset'),
        meta: { guest: true },
    },
    {
        path: '/password/set/:token',
        name: 'set-password',
        component: load('PasswordChange'),
        meta: { guest: true },
    },
    {
        path: '/no-tenant',
        name: 'no-tenant',
        component: load('TenantNotFound'),
        meta: { noTenant: true },
    },
    {
        path: '/',
        component: load('layouts/AuthenticatedLayout'),
        children: [
            {
                path: '',
                redirect: { name: 'home' },
            },
            {
                path: 'dashboard',
                name: 'home',
                component: load('Home'),
                meta: { auth: true },
            },
            {
                path: 'users/create',
                name: 'user.create',
                component: load('user/UserCreate'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
            {
                path: 'users/:userId/edit',
                name: 'user.edit',
                component: load('user/UserEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
            {
                path: 'roles/:roleId/edit',
                name: 'role.edit',
                component: load('role/RoleEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
            ...profileRoutes,
            ...calendarRoutes,
            ...workRoutes,
            ...articleRoutes,
            ...quoteRoutes,
            ...proposalRoutes,
            ...vacationRoutes,
            ...newsletterRoutes,
            ...settingsRoutes,
            ...salesReportRoutes,
            ...statisticRoutes,
            ...evaluatorRoutes
        ],
    },
];
